import { render } from "./easyparcel.vue?vue&type=template&id=708348dc&scoped=true"
import script from "./easyparcel.vue?vue&type=script&lang=js"
export * from "./easyparcel.vue?vue&type=script&lang=js"

import "./easyparcel.vue?vue&type=style&index=0&id=708348dc&scoped=true&lang=css"

import exportComponent from "/Users/aashit.kothari/Documents/jumper-ionic-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-708348dc"]])

export default __exports__